import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadePessoaPaginateResponse } from "./typings/unidade";



interface FiltroUnidadePessoasQuery extends PaginateQuery {
  unidadeId: string;
}

function useUnidadePessoas(
  query: FiltroUnidadePessoasQuery

) {
  return useQuery(
    [`/v1/unidades/${query.unidadeId}/pessoas?${query.page}-${query.limit}-${query.search}`],
    async () => {
      const res = await axios.get<
        PaginateResult<UnidadePessoaPaginateResponse>
      >(`/v1/unidades/${query.unidadeId}/pessoas`, {
        params: { ...query },
      });

      return res.data;
    },
    {
      enabled: !!query.unidadeId,
    }
  );
}

export default useUnidadePessoas;
